import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	&.prompt-container {
		background-color: #202020;
		border-radius: 10px;
		max-width: 750px;
		margin: 50px auto 0;
		box-shadow: 0px 0px 20px 0px rgba(255, 255, 255, 0.15);
		border: 2px solid #464646;

		z-index: 10;
		position: relative;
	}

	.prompt-input {
		padding: 15px 20px 0 20px;

		textarea {
			width: 100%;
			background-color: transparent;
			border: none;
			color: ${CSSVars.white};
			font-size: 16px;
			font-weight: 300;
			font-family: inherit;
			resize: none;
			padding: 0;
			height: 60px;
			outline: none;

			&::placeholder {
				color: rgba(255, 255, 255, 0.7);
			}
		}
	}

	.prompt-options {
		background-color: #202020;
		padding: 0px 15px 15px;
		display: flex;
		align-items: center;
		gap: 8px;
		flex-wrap: wrap;
		border-radius: 0 0 10px 10px;

		.option-button {
			background-color: transparent;
			border: 1px solid #464646;
			color: ${CSSVars.white};
			padding: 3px 10px;
			border-radius: 20px;
			font-size: 14px;
			font-weight: 300;
			font-family: inherit;
			cursor: pointer;
			display: flex;
			align-items: center;
			gap: 6px;
			transition: all 0.2s;

			&.active {
				background-color: #252542;
				border: 1px solid #4c4fff;
			}

			&:hover:not(.active) {
				background-color: #2a2a2a;
			}

			.icon {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 15px;
				height: 15px;
				border-radius: 50%;
				font-size: 14px;
			}
		}

		.or {
			color: white;
			font-size: 14px;
		}

		.select-widget-container {
			position: relative;
			display: inline-block;
		}

		.select-widget-container {
			position: relative;
			display: inline-block;
		}

		.submit-button {
			margin-left: auto;
			color: white;
			border: none;
			width: 30px;
			height: 30px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			transition: 0.3s;
			background: linear-gradient(107deg, #4c4fff 0%, #e9429c 100%), #d9d9d9;

			&:disabled {
				opacity: 0.7;
				cursor: not-allowed;
			}

			&:hover {
				background: linear-gradient(107deg, #3a3dff 0%, #d9429c 100%), #d9d9d9;
			}
		}
	}
`;

export const WidgetPopoverDiv = styled.div`
	border-radius: 10px;
	background-color: #121212;
	border: 1px solid #464646;
	box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.3);

	position: absolute;
	top: calc(100% + 10px);
	left: 50%;
	transform: translateX(-50%) scale(0.9);
	width: 300px;
	max-height: 350px;
	overflow: hidden;
	opacity: 0;
	pointer-events: none;
	transition: all 0.2s;

	&.show {
		transform: translateX(-50%) scale(1);
		opacity: 1;
		pointer-events: all;
	}

	.widget-search {
		position: relative;
		padding: 15px;
		border-bottom: 1px solid #464646;

		.search-icon {
			position: absolute;
			left: 25px;
			top: 25px;
			opacity: 0.7;
		}

		input {
			width: 100%;
			padding: 10px 10px 10px 35px;
			background-color: #2a2a2a;
			border: none;
			border-radius: 6px;
			color: white;
			font-size: 14px;
			outline: none;

			&::placeholder {
				color: #8d8d8d;
			}
		}
	}

	.widget-list {
		overflow-y: auto;
		max-height: 285px;
		padding: 0 0 10px 0;

		&::-webkit-scrollbar {
			width: 8px;
		}

		&::-webkit-scrollbar-track {
			background: #2a2a2a;
		}

		&::-webkit-scrollbar-thumb {
			background: #464646;
			border-radius: 4px;
		}

		.widget-item {
			padding: 10px 15px;
			display: flex;
			align-items: center;
			cursor: pointer;
			transition: background-color 0.2s;

			&:hover {
				background-color: #2a2a2a;
			}

			.widget-icon {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-right: 10px;
			}

			.widget-name {
				font-size: 14px;
				font-weight: 300;
			}
		}
	}
`;
